import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import "./suggestion.scss";
import { giveSuggestion } from "../../services/auth.service";
import { selectUser } from "../../slice/authSlice";
import { useSelector, useDispatch } from "react-redux";

import Form from "react-bootstrap/Form";

import Col from "react-bootstrap/Col";
import { setLoader } from "../../slice/commonSlice";
import { toast } from "react-toastify";

const Suggestion = (props) => {
  const [suggestion, setSuggestion] = useState("");

  let navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector(selectUser);

  const handleChange = (event) => {
    setSuggestion(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    await dispatch(setLoader(true));
    const response = await giveSuggestion(suggestion, user.email);
    if (response.status == 200) {
      props.setsuggestionModal(false);
      toast.success("Suggestion Send Successfully!", {
        position: toast.POSITION.TOP_CENTER,
      });
      await dispatch(setLoader(false));
    } else {
      props.setsuggestionModal(false);
      toast.success("Error while sending suggestion", {
        position: toast.POSITION.TOP_CENTER,
      });
      await dispatch(setLoader(false));
    }

    // You can also add more logic here to handle the submission, like sending the suggestion to a server.
  };
  return (
    <>
      <Modal
        show={props.suggestionModal}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        onHide={() => props.setsuggestionModal(false)}
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="suggestion-modal-wrapper">
            <Col md={12}>
              <div className="suggestion-title">Give Suggestion</div>
              <Form.Group className="mb-3" controlId="bio">
                <Form.Control
                  as="textarea"
                  rows={6}
                  name="bio"
                  placeholder="give suggestion"
                  value={suggestion}
                  onChange={handleChange}
                />
              </Form.Group>
              <button className="submit-btn" onClick={handleSubmit}>
                Submit
              </button>
            </Col>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Suggestion;
